module.exports = __webpack_public_path__ + "img/avatar-10-vector-37332908.ea7010ea.jpg";